import ApiError from "../../errors/ApiError";
import { LINK_CUSTOMER_KROSS_CONNECTION_ERROR } from "./error-codes.constants";

export class LinkCustomerKrossConnectionError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_KROSS_CONNECTION_ERROR);
  }
}
